import { render, staticRenderFns } from "./gPesquisa.vue?vue&type=template&id=30734b46&"
import script from "./gPesquisa.vue?vue&type=script&lang=js&"
export * from "./gPesquisa.vue?vue&type=script&lang=js&"
import style0 from "./gPesquisa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "gPesquisa.vue"
export default component.exports